import { searchRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type'
import axios from 'axios';


export const requestGetAllClients = (queryparams) => async(dispatch) => {
    dispatch(requestShowLoader())
    try {
            const leadSearchUrl = `${process.env.REACT_APP_BASE_URL}companies`;
            const responsedata = await searchRequestData(queryparams , leadSearchUrl , false)
        dispatch({
            type: actionType.RECEIVED_ALL_CLIENTS,
            payload: responsedata?.data
        })
        
    } catch(error) {
        if(error?.response?.status == 401) {
            console.log(error)
        }
    }
    dispatch(requestHideLoader())
}